module.exports = __webpack_public_path__ + "img/home_top_img_head@3x.4a5f1a7a.png";